import { Pipe, PipeTransform } from '@angular/core';
import { parseYMDDate } from '../utils/DateOrNullOrUndefined';

@Pipe({
  name: 'safeDate',
})
export class SafeDatePipe implements PipeTransform {
  transform(value: string | Date): Date | null {
    if (!value) return null;

    if (typeof value === 'string') {
      // If the date is in ISO format, extract just the date part
      if (value.includes('T')) {
        value = value.split('T')[0];
      }
      return parseYMDDate(value);
    }

    return value;
  }
}
